import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import Select from "react-select";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { withTranslation } from "react-i18next";
import {
  addGraderAssignStockList,
  getUserByRoleId,
  updateGraderAssignStock,
  getUserApi,
  getShapes,
  getInclusion,
  updateGraderStock,
  getProcess,
  getFillerInwardStockList,
} from "api";
import * as Yup from "yup";
import {
  categoriTypes,
  status,
  forwardStatus,
  color,
  purity,
  process,
} from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { number, string } from "prop-types";

class GraderAssignScreen2 extends Component {
  constructor(props) {
    console.log(props);
    super(props);

    (async()=>{
      const jangadId = props?.location?.query?.data?.jangadId.split("JANGAD")[1] - 0;
      if(props?.location?.query?.data?.assignGraderToFillerStock !==null && jangadId !==null){
        const fillerInwardStock = await getFillerInwardStockList(jangadId);
        let fillerInwardStockInfo = fillerInwardStock?.data?.stockFillerInWards.map((x)=>x.assignGraderToFillerInWardId);
        if(fillerInwardStockInfo){
          let data = props?.location?.query?.data?.stockGraderInWards.filter((x)=> {
            return fillerInwardStockInfo.includes(x.assignGraderToFillerInWards[0]?.id)
          });
          this.setState({ fillerAcceptedStockList: data })
        }
      }
    })();

    let stockInfo = props?.location?.query?.data?.stockGraderInWards;

    this.state = {
      ...this.props,
      validation: "",
      isDisable: "",
      isSubmit: false,
      fillerList: [],
      shapesList: [],
      processList: [],
      inclusionList: [],
      selectedMulti: null,
      fillerAcceptedStockList:[],
      props: props?.location?.query,
      notEditableRows: props?.location?.query?.data?.stockGraderInWards.map(
        x => x.id
      ),
      expanded: props?.location?.query?.data?.stockGraderInWards.map(x => x.id),
      stockList:
        props?.location?.query?.isEdit == 1
          ? stockInfo.map(x => {
              return {
                id: x.id,
                ar: x.ar == true ? "true" : "false",
                forward_status:x.forward_status == 'f' ? 'f' :'p' ,
                graderStockId: x.graderStockId,
                weight: x.weight,
                weightType: x.weightType,
                outWardPieces: x.outWardPieces,
                diamondStatus: x.diamondStatus,
                outWardWeight: x.outWardWeight,
                shapeId: x.shapeId == null ? "" : x.shapeId,
                inclusionId: x.inclusionId == null ? "" : x.inclusionId,
                iColorId: x.iColorId == null ? "" : x.iColorId,
                colorId: x.iColorId == null ? "" : x.iColorId,
                purityId: x.purityId == null ? "" : x.purityId,
                processId: x.processId == null ? "" : x.process.id,
                process: x.process == null ? "" : x.process,
                remarks: x.remarks,
                nextRemarks: x.nextRemarks,
                pieces: x.stockDataEntryInWard.pieces,
                srNo: x.stockDataEntryInWard.srNo,
                mainJangadId: props.location.query.data.mainJangadId,
                jangadId: props.location.query.data.jangadId,
                dataEntryStockId: props.location.query.data.dataEntryStockId,
                graderStockId: props.location.query.data.id,
                stockDataEntryInWardId: x.stockDataEntryInWardId,
                assignGraderToFillerInWards: x.assignGraderToFillerInWards,
              };
            })
          : stockInfo.map(x => {
              return {
                id: x.id,
                ar: x.ar == true ? "true" : "false",
                forward_status:x.forward_status == 'f' ? 'f' :'p',
                graderStockId: x.graderStockId,
                weight: x.weight,
                weightType: x.weightType,
                diamondStatus: x.diamondStatus,
                shapeId: x.shapeId == null ? "" : x.shapeId,
                shape: x.shape == null ? "" : x.shape,
                inclusion: x.inclusion == null ? "" : x.inclusion,
                inclusionId: x.inclusionId == null ? "" : x.inclusionId,
                iColorId: x.iColorId == null ? "" : x.iColorId,
                colorId: x.iColorId == null ? "" : x.iColorId,
                purityId: x.purityId == null ? "" : x.purityId,
                processId: x.process == null ? "" : x.process.id,
                process: x.process == null ? "" : x.process,
                remarks: x.remarks,
                nextRemarks: x.nextRemarks,
                pieces: x.stockDataEntryInWard.pieces,
                srNo: x.stockDataEntryInWard.srNo,
                mainJangadId: props.location.query.data.mainJangadId,
                jangadId: props.location.query.data.jangadId,
                dataEntryStockId: props.location.query.data.dataEntryStockId,
                graderStockId: props.location.query.data.id,
                stockDataEntryInWardId: x.stockDataEntryInWardId,
                assignGraderToFillerInWards: x.assignGraderToFillerInWards,
              };
            }),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  validateTable() {
    for (let i = 0; i < this.state.stockList.length; i++) {
      let e = this.state.stockList[i];

      if (e.ar == "true" || e.ar == true) {
        if (
          e.shapeId == "" ||
          e.iColorId == "" ||
          e.purityId == "" ||
          e.assignGraderToFillerInWards.filter(x => x.processId == "").length !=
            0 ||
          e.processId == ""
        ) {
          return false;
        }
      } else {
        if (
          e.shapeId == "" ||
          e.iColorId == "" ||
          e.purityId == "" 
        ) {
          return false;
        }
      }
    }
    return true;
  }

  async componentDidMount() {
    $('#fillername').on('change', function() {
      if (this.value) {
        $("#filleriderror").hide();
      }
    });
    const shape = await getShapes();
    if (shape && shape.data) {
      this.setState({
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const process = await getProcess();
    console.log(process);
    if (process && process.data) {
      this.setState({
        processList: [
          { label: "NONE", value: "" },
          ...process.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const inclusion = await getInclusion();
    if (inclusion && inclusion.data) {
      this.setState({
        inclusionList: [
          ...inclusion.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const filler = await getUserApi({
      factoryId: this.state.props.data.jangad.factory.id,
      roleId: "ROLE0000003",
    });
    if (filler && filler.data) {
      this.setState({
        fillerList: filler.data.users,
      });
    }

    this.setState({
      stockList: this.state.stockList.map(x => {
        return {
          ...x,
          inclusionId:
            x.inclusionId == null
              ? []
              : this.state.inclusionList.filter(y =>
                  x.inclusionId.includes(y.value)
                ),
        };
      }),
    });
    // if(this.state.props.data.assignGraderToFillerStock !==null){
    //   for(var i = 1; i <=this.state.stockList.length; i++) {
    //   // $(`.${i}gradersavebtn`).hide();
    // }
    // }
    
    const jangadId = this.state.props?.data?.jangadId.split("JANGAD")[1] - 0;
    if(this.state.props.data?.assignGraderToFillerStock !== null && jangadId !== null){
      const fillerInwardStock = await getFillerInwardStockList(jangadId);
      let fillerInwardStockInfo = fillerInwardStock?.data?.stockFillerInWards.map((x)=>x.assignGraderToFillerInWardId);
      if(fillerInwardStockInfo){
        const stockInfo = this.state?.stockList.filter((x)=> {
          return !fillerInwardStockInfo.includes(x.assignGraderToFillerInWards[0]?.id)
        });
        this.setState({ stockList: stockInfo });
      }
    }

    this.validateTable();
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }

  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          inWardRemarks: "",
          forNextPersonRemarks: "",
          status: "true",
          assignProcess: 0,
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }
  
  saveStockInfo = async values =>{
    var element = document.getElementById("invalid");
    var fillerId = document.getElementById("fillername");
    const color = values.iColorId
    const purity = values.purityId
    const process = values.processId
    
    if(fillerId.value !== ""){
      $("#filleriderror").hide();
      
      if((fillerId.value !== "" &&color == "" && purity  == "" &&process == "") || color == "" || purity  == "" ||process == ""){
        this.setState({
          isSubmit:true,
        });
      }else {
        // console.log('values::',values);
        const validStockData = this.state.stockList.filter((x)=>x.iColorId !== "" && x.purityId !== "" && x.processId !== "");
        // console.log("validStockData",validStockData);
        let id = this.state.props.data.id;
        let temp = {
          cycle: 1,
          assignStatus: this.state.props.data.assignStatus,
          dataEntryStockId: this.state.props.data.dataEntryStockId,
          jangadId: this.state.props.data.jangadId,
          mainJangadId: this.state.props.data.mainJangadId,
          dataEntryStockId: this.state.props.data.dataEntryStockId,
          graderStockId: this.state.props.data.graderStockId,
          fillerId:fillerId.value,
          cycle: values.cycle,
          remarks: values.remarks,
          nextRemarks: values.nextRemarks,
          fillerStatus: "P",
          assignGraderToFillerStock:
            this.state.props.data.assignGraderToFillerStock,
          stockGraderInWards: validStockData.map(x => {
            return {
              ...x,
              assignGraderToFillerInWards: x.assignGraderToFillerInWards.map(
                y => {
                  if (x.processId && y.cycle == 1) {
                    (y.nextRemarks = x.nextRemarks),
                      (y.processId = parseInt(x.processId));
                  }
                  return y;
                }
              ),
              colorId: x.iColorId,
              mainJangadId: this.state.props.data.mainJangadId,
              jangadId: this.state.props.data.jangadId,
              dataEntryStockId: this.state.props.data.dataEntryStockId,
              graderStockId: this.state.props.data.id,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              inclusionId: x.inclusionId.map(y => y.value),
              forward_status:x.ar== 'false' ? 'r':x.forward_status
            };
          }),
        };
        const data = await updateGraderStock({ data: temp, id: id });
      }
     
    } else {
      if (!fillerId?.value) {
        $("#filleriderror").show();
      }
      this.setState({
        isSubmit:true,
      });
      if(element){
        element.innerText = 'this value is required'
      }
    }
 
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let temp = {
        cycle: 1,
        assignStatus: this.state.props.data.assignStatus,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        jangadId: this.state.props.data.jangadId,
        mainJangadId: this.state.props.data.mainJangadId,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        graderStockId: this.state.props.data.graderStockId,
        remarks: values.remarks,
        nextRemarks: values.nextRemarks,
        fillerId: values.fillerId,
        assignGraderToFillerInWards: this.state.stockList,
        cycle: 1,
        graderStockId: this.state.props.data.dataEntryStock.graderStock.id,
      };
      const data = await addGraderAssignStockList(temp);
      // this.props.history.goBack();
    } else {
      let id = this.state.props.data.id;
      const validStockData = this.state.stockList.filter((stock)=>stock.assignGraderToFillerInWards.length==0);

      let temp = {
        cycle: 1,
        assignStatus: this.state.props.data.assignStatus,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        jangadId: this.state.props.data.jangadId,
        mainJangadId: this.state.props.data.mainJangadId,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        graderStockId: this.state.props.data.graderStockId,
        fillerId: values.fillerId,
        cycle: values.cycle,
        remarks: values.remarks,
        nextRemarks: values.nextRemarks,
        fillerStatus: "P",
        assignGraderToFillerStock:
          this.state.props.data.assignGraderToFillerStock,
        stockGraderInWards: validStockData.map(x => {
          return {
            ...x,
            assignGraderToFillerInWards: x.assignGraderToFillerInWards.map(
              y => {
                if (x.processId && y.cycle == 1) {
                  (y.nextRemarks = x.nextRemarks),
                    (y.processId = parseInt(x.processId));
                }
                return y;
              }
            ),
            colorId: x.iColorId,
            mainJangadId: this.state.props.data.mainJangadId,
            jangadId: this.state.props.data.jangadId,
            dataEntryStockId: this.state.props.data.dataEntryStockId,
            graderStockId: this.state.props.data.id,
            stockDataEntryInWardId: x.stockDataEntryInWardId,
            inclusionId: x.inclusionId.map(y => y.value),
            forward_status:x.ar== 'false' ? 'r':x.forward_status
          };
        }),
      };


      const data = await updateGraderStock({ data: temp, id: id });
      // this.props.history.goBack();
    }

    // values.stockGraderInWards = this.state.stockList;
    // delete values.partyCode;
    // if (this.state.props.isEdit == 1) {
    //   let id = this.state.props.data.dataEntryStock.graderStocks.reduce(
    //     (prev, current) => {
    //       return prev.cycle > current.cycle ? prev : current;
    //     }
    //   ).id;

    //   console.log(values);

    // } else {
    //   const data = await updateGraderAssignStock(values);
    // }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "filler flow";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        sort: true,
        editable: false,
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: (columnData, row) => {
          return this.state.stockList
            .filter(x => x.ar == true || x.ar == "true")
            .reduce((acc, item) => acc + item.pieces, 0)
            .toFixed(2);
        },
        editable: false,
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: "",
        footer: columnData =>
          this.state.stockList
            .filter(x => x.ar == true || x.ar == "true")
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2),
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },

      {
        dataField: "iColorId",
        text: `${this.props.t("Color")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: color,
        },
        formatter: (cell, row) => {
          return color.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color = cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { color, background };
        },
      },
      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.shapesList,
        },
        formatter: (cell, row) => {
          if (cell == "") {
            return "NONE";
          } else if (
            parseInt(cell) > 0 &&
            this.state.props.isEdit != 1 &&
            cell == row.shape.id
          ) {
            return row.shape.name;
          } else {
            return this.state.shapesList?.filter(x => x.value == cell)[0]
              ?.label;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color = cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { color, background };
        },
      },
      {
        dataField: "inclusionId",
        text: `${this.props.t("Inclusion")}`,
        footer: "",
        // editor: {
        //   type: Type.SELECT,
        //   options: this.state.inclusionList,
        // },
        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          row.inclusionId = row.inclusionId.map(x => {
            return typeof x == "number"
              ? this.state.inclusionList.filter(x => x.value == x)[0]
              : x;
          });
          return (
            <div className="mb-3 select2-container">
              <Select
                value={row.inclusionId.map(x => {
                  return typeof x == "number"
                    ? this.state.inclusionList.filter(x => x.value == x)[0]
                    : x;
                })}
                isMulti={true}
                onChange={e => {
                  row.inclusionId = e;
                  this.setState({ selectedMulti: null });
                }}
                options={this.state.inclusionList}
              />
            </div>
          );
        },
        formatter: (cell, row) => {
          if (row.inclusionId.length && typeof row.inclusionId[0] != "number") {
            let temp = [];
            temp = row.inclusionId.map(x =>
              typeof x == "number" ? x : x.value
            );
            return this.state.inclusionList
              .filter(x => temp.includes(x.value))
              .map(x => (
                <span key={x.value} className="border border-1 px-1 py-1 m-1">
                  {x.label}
                </span>
              ));
          } else {
            return "NONE";
          }
        },
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },
      {
        dataField: "purityId",
        text: `${this.props.t("Purity")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: purity,
        },
        formatter: (cell, row) => {
          return purity.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          const color = cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color, background };
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Inward Remarks")}`,
        footer: "",
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
        style: (cell, row) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },
      {
        dataField: "ar",
        text: `${this.props.t("Status")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: status,
        },
        formatter: (cell, row) => {
          if (row.diamondStatus == "A") {
            row.ar = false;           
            return row.ar == true || row.ar == "true" ? "Accept" : "Reject";
          } 
          else
              if(row.ar == ""){
                 return row.ar == "" ? "NONE" : "Accept";
               }
            return row.ar == true || row.ar == "true" ? "Accept" : "Reject";
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color = row.ar == "" && this.state.isSubmit == true ? "red" : "#495057";
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { color, background };
        },
      },
      {
        dataField: "forward_status",
        text: `${this.props.t("Forward Status")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: forwardStatus,
        },
        formatter: (cell, row) => {
          console.log('row',row.forward_status);
          if (row.diamondStatus == "A") {
            row.forward_status = 'f';
            return row.forward_status == "p" ? "Pending" : "Forward";
          }
          else
               if(row.forward_status == ""){
                return row.forward_status == "" ? "NONE" : "Pending";
               }
               if(row.forward_status == "f"){
                    return row.forward_status == "f" ? "Forward" : "Pending";
               }

               if(row.forward_status == "r"){
                   return row.forward_status == "r" ? "Reject" : "Pending";
               }
              
            return row.forward_status == "p" ? "Pending" : "Forward";
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color = row.forward_status == "" && this.state.isSubmit == true ? "red" : "#495057";
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { color, background };
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.processList,
        },
        formatter: (cell, row) => {
          console.log(row.id, this.state.processList);
          if (this.state.processList.length == 0) {
            return row.process.name;
          } else if (cell == "") {
            return "NONE";
          } else if (
            parseInt(cell) > 0 &&
            this.state.props.isEdit != 1 &&
            cell == row.process.id
          ) {
            return row.process.name;
          } else {
            console.log("else part");

            return this.state.processList?.find(x => x.value == cell)?.label;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color = cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { color, background };
        },
      },
      {
        dataField: "edit",
        text: `${this.props.t("Action")}`,
        footer: "",

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
            
           {/* <button
            className="bg-transparent border-0 ms-3"
            onClick={() => console.log('hello kkrish')}
          >
            <img src="images/dashboard-images/deleteRow.svg"></img>
           </button>*/}
           <button
           type="button"
           className={`border-0 p-2 btn-active raised-btn rounded ms-3 ${row.srNo}gradersavebtn`}
           onClick={() =>
             this.saveStockInfo(row)
           }
         >
           {" "}
           Save{" "}
         </button>
          
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="btn-group">
          
              <button
              type="button"
              className={`border-0 p-2 btn-active raised-btn rounded ms-3 ${row.srNo}gradersavebtn`}
              onClick={() =>
                this.saveStockInfo(row)
              }
            >
              {" "}
              Save{" "}
            </button>
           
          </div>
        ),
        style: (cell, row, rowIndex, colIndex) => {
          let background = '';
          if (row?.ar == 'true' && row?.forward_status == 'f' && row?.colorId && row?.purityId && row?.processId) {
            background = '#FFE6B8';
          }
          return { background };
        },
      },

      // {
      //   dataField: "edit",
      //   text: `${this.props.t("Edit Data")}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         {/* <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() => this.deleteRow(rowIndex)}
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button> */}
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //       {/* <button
      //         className="bg-transparent border-0 ms-3"
      //         onClick={() => this.deleteRow(rowIndex)}
      //       >
      //         <img src="images/dashboard-images/deleteRow.svg"></img>
      //       </button> */}
      //     </div>
      //   ),
      // },
    ];
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];

    // let updateFiller;
    // if (this.state.props.isEdit != 1) {
    //   updateFiller = this.state.props.data.dataEntryStock.graderStock;
    // }
    document.title = "grader flow";

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Assign Screen")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        fillerId: "",
                        category:
                          this.state.props.data.mainJangad.category.name,
                        // fillerId: this.state.props.data.fillerId,
                        remarks: this.state.props.data.remarks,
                        nextRemarks: this.state.props.data.nextRemarks,
                      }
                    : {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        fillerId: this.state.props.data
                          .assignGraderToFillerStock
                          ? this.state.props.data.assignGraderToFillerStock
                              .fillerId
                          : "",
                        category:
                          this.state.props.data.mainJangad.category.name,
                        // fillerId: "",
                        remarks: this.state.props.data.remarks,
                        nextRemarks: this.state.props.data.nextRemarks,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string(),
                  partyCode: Yup.string().required("This value is required"),
                  fillerId: Yup.string().required("This value is required"),
                  // fillerId: Yup.string().required("This value is required"),

                  remarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                  nextremarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                })}
                onSubmit={() => {}}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  isValid,
                  isValidating,
                  isSubmitting,
                  validateOnMount,
                  validateForm,
                  validateField,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("Assign Screen")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Assign Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <Row>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="category"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Diamond Category")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.category && touched.category
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.data ? true : false
                                  }
                                  type="text"
                                  name="category"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="fillerId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.fillerId && touched.fillerId
                                      ? " is-invalid"
                                      : "") 
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  name="fillerId"
                                  as="select"
                                  id='fillername'
                                >
                                  <option value="">All</option>
                                  {this.state.fillerList?.map(x => (
                                    <option value={x.id} key={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                  </Field>
                                <ErrorMessage
                                  name="fillerId"
                                  component="div"
                                  id='invalid'
                                  className="invalid-feedback"
                                />
                                <div id="filleriderror" className="invalid-feedback" style={{"display": "none"}}>This value is required</div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="remarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Grader Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.remarks && touched.remarks 
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="remarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="nextRemarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.nextRemarks && touched.nextRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="nextRemarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="nextRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </Row>
                        </CardBody>
                      </div>
                      {this.state.props.isEdit == 3 ? (
                        ""
                      ) : (
                        <>

                      <div className="row px-3 pt-3">
                            <div className="d-flex justify-content-between">
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Filler Accepted stock Details")}
                              </h3>
                            </div>

                            <div className="table-responsive">
                           
                            <table className="table border table-responsive background-light foo border-1">
                            <thead>
                              <tr>
                                <th scope="col">
                                  {this.props.t("SR No.")}
                                </th>
                                <th scope="col">
                                  {this.props.t("Pieces")}
                                </th>
                                <th scope="col">
                                  {this.props.t(
                                    "Weight"
                                  )}
                                </th>
                              
    
                                <th scope="col">
                                  {this.props.t("Color")}
                                </th>
                                <th scope="col">
                                {this.props.t("Shapes")}
                              </th>
                                <th scope="col">
                                {this.props.t("Inclusion")}
                              </th> 
                                <th scope="col">
                                  {this.props.t("Purity")}
                                </th>
                              
                                <th scope="col">
                                  {this.props.t("Inward Remarks")}
                                </th>
                                <th scope="col">
                                  {this.props.t("For Next Person Instructions")}
                                </th>
                                <th scope="col">
                                  {this.props.t("Status")}
                                </th>
                                <th scope="col">
                                  {this.props.t("Process")}
                                </th>
                              </tr>
                            </thead>
                           {
                            this.state.fillerAcceptedStockList.map((x,index)=>
                              <tbody key={index}>
                                                    <tr>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                        {
                                                          x.stockDataEntryInWard
                                                            .srNo
                                                        }
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                        {x.stockDataEntryInWard.pieces}
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                        {
                                                          x.stockDataEntryInWard.weight+" CT"
                                                        }
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                      >
                                                        {
                                                          color.filter(z => {
                                                            return (
                                                              z.value ==
                                                              x
                    
                                                                .iColorId
                                                            );
                                                          }).length
                                                            ? color.filter(
                                                                z => {
                                                                  return (
                                                                    z.value ==
                                                                    x
                                                                      
                                                                      .iColorId
                                                                  );
                                                                }
                                                              )[0].label
                                                            : ""
                                                        }
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                        {
                                                          x.shape.name
                                                        }
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                        {
                                                         x.inclusionId.length == 0 ?"None":""
                                                        }
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                        scope="row"
                                                      >
                                                      
                                                          {purity.filter(z => {
                                                            return (
                                                              z.value ==
                                                              x
                                                                .purityId
                                                            );
                                                          }).length
                                                            ? purity.filter(
                                                                z => {
                                                                  return (
                                                                    z.value ==
                                                                    x
                                                                      .purityId
                                                                  );
                                                                }
                                                              )[0].label
                                                            : ""}
                                                        
                                                      </td>
                                                      
                                                      <td
                                                        className="bg-success-green"
                                                      >
                                                        {x?.remarks || ''}
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                      >
                                                        {x?.nextRemarks || ''}
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                      >
                                                        {x.ar == true ?"Accept" :"Reject"}
                                                      </td>
                                                      <td
                                                        className="bg-success-green"
                                                      >
                                                        {x.process.name}
                                                      </td>
                                                      
                                                    </tr>
                                                  </tbody>
                            )
                           }
                          </table>
                            </div>
                              </div>

                          <div className="row px-3 pt-3">
                            <div className="d-flex justify-content-between">
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Enter stock Details")}
                              </h3>
                              {/* <button
                            type="button"
                            className="bg-transparent border-0"
                            onClick={() => this.addRow()}
                          >
                            <img
                              src="images/dashboard-images/addRow.svg"
                              alt="add Row"
                            />
                          </button> */}
                            </div>

                            <div className="table-responsive">
                              <BootstrapTable
                                rowStyle={(row, rowIndex) => {}}
                                keyField="id"
                                classes="foo"
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                data={this.state.stockList}
                                columns={this.columns1}
                                defaultSorted={defaultSorted}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  // nonEditableRows: () =>
                                  //   this.state.notEditableRows,
                                  afterSaveCell: () => {
                                    this.setState({
                                      stockList: [...this.state.stockList],
                                    });
                                  },
                                })}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Stock summary")}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            defaultSorted={defaultSorted}
                            data={this.state.stockList}
                            columns={this.columns1}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        {this.state.props.isEdit == 3 ? (
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        ) : (
                          <>
                            <Button
                              color="primary"
                              className="fs-4 px-5 me-2"
                              type="submit"
                              onClick={() => this.state.history.goBack()}
                            >
                              Back
                            </Button>
                            <Button
                              color="primary"
                              className="fs-4 px-5 me-3"
                              type="submit"
                              onClick={async () => {
                                this.setState({ isSubmit: true }, async () => {
                                  console.log(this.validateTable());
                                  if (this.validateTable()) {
                                    await validateForm()
                                      .then(data => {
                                        if (Object.keys(data).length == 0) {
                                          this.handleSubmit(event, values);
                                        }
                                      })
                                      .catch(err => console.log("err =>", err));
                                  }
                                });
                              }}
                            >
                              Update
                            </Button>

                            {/* {this.state.props.data?.assignGraderToFillerStocks?.length ? (
                              ""
                            ) : this.validateTable() == false ? (
                              ""
                            ) : (
                              <Link
                                to={{
                                  pathname: "/grader-assign-screen",
                                  query: {  isEdit:
                                      this.state.props.data?.assignGraderToFillerStocks?.length > 0
                                        ? 2
                                        : 1,
                                    data: this.state.props.data,
                                  },
                                }}
                              >
                                <Button
                                  color="primary"
                                  className="fs-4 px-5"
                                  disabled={
                                    this.validateTable() == false ? true : false
                                  }
                                  type="submit"
                                >
                                  Assign
                                </Button>
                              </Link>
                            )} */}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(GraderAssignScreen2);
